import { Button } from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import OutlinedInput from "@mui/material/OutlinedInput";

const infoTableCellSx = {
  fontSize: 17,
};

// 検索フォーム
const SearchForm = (props) => {
  const { searchData } = props;

  function search() {
    props.search(searchData.Value);
  }

  return (
    <Box border="1px solid blue" borderRadius={1} padding={2}>
      フィルター
      <Box margin={2} marginBottom={1}>
        <Grid container alignItems="center" marginBottom={1} spacing={6}>
          <Grid item xs="auto">
            買人（No・名）:&nbsp;
            <OutlinedInput
              sx={{ width: 250 }}
              onChange={(e) => searchData.update("buyer", e.target.value)}
              value={searchData.Value.buyer}
            />
          </Grid>
          <Grid
            container
            alignItems="center"
            justifyContent="flex-end"
            spacing={1}
          >
            <Grid item xs="auto">
              <Button variant="contained" onClick={search}>
                検索
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default SearchForm;
